import _ from 'underscore';
import { INotification, TargetComponent, NotificationLevel, DismissMode, ScopeLevel, IContext } from '../../types';
import { isBillingLinkPermission } from '../../utils';

const notificationTitle = _TL_('Hotel Center to Lodging campaigns migration ');
const notificationMessage = _TL_('As of February 6, 2024, we’ll change the set up and management of Hotel price ads and Property promotion ads. You’ll still be able to manage any campaigns for hotels and vacation rentals using the enhanced Lodging campaigns.{{br}}Please review our {{guideLinkPrefix}}Lodging Campaigns Guide{{guideLinkSuffix}} to help you migrate to Lodging campaigns using bulk upload or API. You can also {{helpLinkPrefix}}create Lodging campaigns within the Microsoft Advertising Platform{{helpLinkSuffix}}.{{br}}{{blogLinkPrefix}}Read more about this migration.{{blogLinkSuffix}}');

export class HotelCenterMigrationNotification {
  context: IContext;
  i18n: any;
  availableScopes: ScopeLevel[];

  constructor(context: IContext) {
    this.context = context;
    this.i18n = context.getNewI18n();
    this.availableScopes = [ScopeLevel.account, ScopeLevel.customer];
  }

  async getHotelCenterMigrationNotifications() {
    if (!this.context.getUserContext().CurrentUser.IsInternal && isBillingLinkPermission(this.context.getSettingsContext())) {
      return [];
    }

    const serverContext = this.context.getServerContext();
    const isHotelCenterEnabled = serverContext && serverContext.DynamicPermissions.HotelAds;
    const isHotelCenterRemovalEnabled = serverContext && serverContext.DynamicPermissions.HotelCenterRemoval;
    if (!isHotelCenterEnabled || isHotelCenterRemovalEnabled) {
      return [];
    }

    const replaceMap = {
      br: '<br/><br/>',
      guideLinkPrefix: '<a href="https://learn.microsoft.com/en-us/advertising/guides/campaign-management-guides?view=bingads-13" target="_blank">',
      guideLinkSuffix: '</a>',
      helpLinkPrefix: '<a href="https://help.ads.microsoft.com/#apex/ads/en/60154/1" target="_blank">',
      helpLinkSuffix: '</a>',
      blogLinkPrefix: '<a href="https://about.ads.microsoft.com/en-us/blog/post/january-2024/upcoming-changes-to-hotel-center-subaccounts" target="_blank">',
      blogLinkSuffix: '</a>',
    };

    let finalMessage = this.i18n.getString(notificationMessage);
    Object.keys(replaceMap).forEach((key) => {
      finalMessage = finalMessage.replaceAll(`{{${key}}}`, replaceMap[key]);
    });

    // Get notifications
    const notifications: INotification[] = [{
      id: 'HotelCenterMigration',
      condition: true,
      target: TargetComponent.UnifiedQueue,
      dismissMode: DismissMode.session,
      severity: NotificationLevel.Info,
      scopeLevel: ScopeLevel.account,
      availableScopes: this.availableScopes,
      title: this.i18n.getString(notificationTitle),
      message: finalMessage,
      actionList: [
        {
          text: this.i18n.getString(_TL_('Contact Support')),
          action: () => {
            window.open('https://about.ads.microsoft.com/en-us/microsoft-advertising-support');
          },
          callbackType: 'closeQueue',
          extraClassNames: ['hotel-center-migration-contact-support'],
        },
      ],
    }];


    return _.compact(notifications);
  }
}
